export default __webpack_public_path__ + "static/media/uber-467x529.e6321909.jpg";